import edjsHTML from "editorjs-html";

/**
 * Custom EditorJS HTML parser for `simpleImage` blocks.
 * @param {{ data: { url: string } }} block
 * @returns {string} HTML `<img>` string.
 */
const simpleImageParser = (block) => {
  return `  <img className="mx-auto" src={${block.data.url}}/>`;
};

/**
 * Custom EditorJS HTML parser for `raw` blocks; returns the raw HTML as-is.
 * @param {{ data: { html: string } }} block
 * @returns {string}
 */
const rawParser = (block) => {
  return block.data.html;
};

/** Configured EditorJS-to-HTML parser instance with custom `simpleImage` and `raw` block parsers. */
const edjsParser = edjsHTML({ simpleImage: simpleImageParser, raw: rawParser });

export default edjsParser;
